"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _responsive = require("../responsive");

var _screenReaderOnly = require("../screen-reader-only");

var _utils = require("../utils");

var _EllipsisItem = _interopRequireDefault(require("./EllipsisItem"));

var _NavigationButtons = require("./NavigationButtons");

var _PaginationButton = _interopRequireDefault(require("./PaginationButton"));

var _constants = require("./constants");

var _helperComponents = require("./helperComponents");

var _helpers = require("./helpers");

var _interfaces = require("./interfaces");

var _propTypes = require("./propTypes");

var _core = require("@emotion/core");

var _excluded = ["aria-label", "aria-labelledby", "generateButtonAriaLabel", "getSelectedPageHiddenText", "numberOfPages", "onPageSelect", "selectedPage", "variant"];

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var Pagination = function Pagination(_ref) {
  var _ref$ariaLabel = _ref['aria-label'],
      ariaLabel = _ref$ariaLabel === void 0 ? _constants.paginationDefaultProps['aria-label'] : _ref$ariaLabel,
      ariaLabelledBy = _ref['aria-labelledby'],
      _ref$generateButtonAr = _ref.generateButtonAriaLabel,
      generateButtonAriaLabel = _ref$generateButtonAr === void 0 ? _constants.paginationDefaultProps.generateButtonAriaLabel : _ref$generateButtonAr,
      _ref$getSelectedPageH = _ref.getSelectedPageHiddenText,
      getSelectedPageHiddenText = _ref$getSelectedPageH === void 0 ? _constants.defaultGetSelectedPageHiddenText : _ref$getSelectedPageH,
      numberOfPages = _ref.numberOfPages,
      onPageSelect = _ref.onPageSelect,
      selectedPage = _ref.selectedPage,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? _constants.paginationDefaultProps.variant : _ref$variant,
      forwardedProps = (0, _objectWithoutProperties2.default)(_ref, _excluded);

  var _useBreakpoints = (0, _responsive.useBreakpoints)({
    propsMap: {
      s: _constants.CONFIGURATION_SMALL,
      default: _constants.CONFIGURATION_DEFAULT
    }
  }),
      configuration = _useBreakpoints.props;

  var visiblePageNumbers = (0, _helpers.getVisiblePageNumbers)({
    configuration: configuration,
    numberOfPages: numberOfPages,
    selectedPage: selectedPage,
    variant: variant
  });
  var isDottedVariant = variant === _interfaces.PaginationVariant.Dotted;

  var handlePrevButtonClick = function handlePrevButtonClick() {
    onPageSelect(selectedPage - 1); //move the focus to first Page when the selected Page is 2 and clicked event happens.
    //click event on PreviousPageButton never occurs when selectedPage is the first page.

    if (selectedPage === 2 && firstPageRef && firstPageRef.current) {
      firstPageRef.current.focus();
    }
  };

  var handleNextButtonClick = function handleNextButtonClick() {
    //move the focus to last Page when the selected Page is one before the last and clicked event happens.
    //click event on NextPageButton never occurs when selectedPage is the last page.
    if (selectedPage === numberOfPages - 1 && lastPageRef && lastPageRef.current) {
      lastPageRef.current.focus();
    }

    onPageSelect(selectedPage + 1);
  };

  var renderPageButton = function renderPageButton(pageNumber, index) {
    if (pageNumber === undefined) return null;

    if (pageNumber === -1) {
      return (0, _core.jsx)(_EllipsisItem.default, {
        key: "ellipsis-".concat(index)
      });
    }

    var isFirstPage = pageNumber === 1;
    var isLastPage = pageNumber === numberOfPages;

    var handlePageNumberRef = function handlePageNumberRef(node) {
      if (isFirstPage) {
        firstPageRef.current = node;
      }

      if (isLastPage) {
        lastPageRef.current = node;
      }
    };

    var paginationButtonProps = {
      'aria-label': generateButtonAriaLabel({
        pageNumber: pageNumber,
        isFirstPage: isFirstPage,
        isLastPage: isLastPage
      }),
      dataTestId: pageNumber.toString(),
      isSelected: pageNumber === selectedPage,
      onClick: function onClick() {
        return onPageSelect(pageNumber);
      },
      ref: handlePageNumberRef
    };
    return (0, _core.jsx)(_helperComponents.PaginationLi, {
      key: "page-".concat(pageNumber)
    }, isDottedVariant ? (0, _core.jsx)(_helperComponents.PaginationButtonDot, paginationButtonProps) : (0, _core.jsx)(_PaginationButton.default, paginationButtonProps, pageNumber));
  };

  var renderPageButtons = function renderPageButtons() {
    // flatmap is required over map to prevent buttons unmounting and remounting when ellipsis
    // icons are added or removed this causes focus to be lost when navigating through pages
    // https://t.corp.amazon.com/D90006470
    var flattenedPageNumbers = visiblePageNumbers.flatMap(function (section, index) {
      return [].concat((0, _toConsumableArray2.default)(section), [section && index !== visiblePageNumbers.length - 1 ? -1 : undefined]);
    });
    return flattenedPageNumbers.map(renderPageButton);
  };

  var firstPageRef = (0, _react.useRef)(null);
  var lastPageRef = (0, _react.useRef)(null);
  return (0, _core.jsx)(_helperComponents.PaginationNav, (0, _extends2.default)({
    "aria-label": ariaLabel,
    "aria-labelledby": ariaLabelledBy
  }, (0, _utils.pickDataProps)(forwardedProps)), (0, _core.jsx)(_NavigationButtons.PreviousPageButton, {
    "aria-label": generateButtonAriaLabel({
      isPreviousButton: true
    }),
    "aria-disabled": selectedPage === 1,
    onClick: handlePrevButtonClick,
    tabIndex: selectedPage === 1 ? -1 : 0,
    paginationVariant: variant
  }), (0, _core.jsx)(_helperComponents.PaginationContainer, {
    gridGap: isDottedVariant ? 0 : undefined
  }, renderPageButtons()), (0, _core.jsx)(_NavigationButtons.NextPageButton, {
    "aria-label": generateButtonAriaLabel({
      isNextButton: true
    }),
    "aria-disabled": selectedPage === numberOfPages,
    onClick: handleNextButtonClick,
    tabIndex: selectedPage === numberOfPages ? -1 : 0,
    paginationVariant: variant
  }), (0, _core.jsx)(_screenReaderOnly.ScreenReaderOnly, {
    "aria-live": "polite",
    role: "status",
    "aria-relevant": "text"
  }, getSelectedPageHiddenText(selectedPage)));
};

var _default = (0, _utils.composeStencilComponent)({
  baseComponent: Pagination,
  description: 'UI for navigating between multiple pages of content.',
  defaultProps: _constants.paginationDefaultProps,
  displayName: 'Pagination',
  propTypes: _propTypes.paginationPropTypes
});

exports.default = _default;